var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.334,
    height: 54.688,
    viewBox: "0 0 62.334 54.688",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-165.627 -303.782)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.4,398.008a1.979,1.979,0,0,0-2.728.634,23.384,23.384,0,0,1-42.614-6.951l1.528-.126a2.387,2.387,0,0,0,1.766-3.738l-4.209-6.078a2.387,2.387,0,0,0-4.121.339l-3.159,6.684a2.387,2.387,0,0,0,2.354,3.4l1.85-.152a27.348,27.348,0,0,0,49.967,8.717A1.98,1.98,0,0,0,219.4,398.008Z",
    transform: "translate(0 -55.172)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.507,325.237l-1.821.159a27.348,27.348,0,0,0-49.645-9.209,1.98,1.98,0,0,0,.629,2.775,2.041,2.041,0,0,0,2.734-.681,23.383,23.383,0,0,1,42.295,7.463l-1.557.136a2.387,2.387,0,0,0-1.747,3.747l4.24,6.056a2.387,2.387,0,0,0,4.119-.36l3.125-6.7A2.387,2.387,0,0,0,245.507,325.237Z",
    transform: "translate(-20.144)",
    fill: "#1a1818"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.04b30f9abe38c5845d6a6d841bfd3009.svg";
export { ForwardRef as ReactComponent };